import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createHead } from '@vueuse/head'

import { VueCookieNext } from 'vue-cookie-next'
VueCookieNext.config({
  expire: '7d',
  sameSite: 'Lax'
})

import DefaultLayout from '@/layout/DefaultLayout.vue'
import NoneLayout from '@/layout/NoneLayout.vue'

import './assets/sass/common.sass'

const head = createHead()

const app = createApp(App)
app
  .use(store).use(head).use(router).use(VueCookieNext)
  .component('default-layout', DefaultLayout).component('none-layout', NoneLayout)
  .mount('#app')
